module.exports = __webpack_public_path__ + "img/r-150.4e619ffc.jpg";